import { fetchWithCache } from "../utils/cache";

// Static JSON from same origin (/api/*.json). Run "npm run generate-api" (or prebuild) so public/api/*.json exist.
const API_PATH = "/api";

const getUrl = (endpoint) => `${API_PATH}/${endpoint}.json`;

const fetchData = async (endpoint) => {
  try {
    return await fetchWithCache(getUrl(endpoint));
  } catch (error) {
    console.error(`Error fetching ${endpoint}:`, error);
    throw error;
  }
};

export const api = {
  getOrganization: () => fetchData("organization"),
  getSecretary: () => fetchData("secretary"),
  getStats: () => fetchData("stats"),
  getThematicAreas: () => fetchData("thematicAreas"),
  getOperationalAreas: () => fetchData("operationalAreas"),
  getRegistrationDetails: () => fetchData("registrationDetails"),
  getOffices: () => fetchData("offices"),
  getWorkingHours: () => fetchData("workingHours"),
  getQuickLinks: () => fetchData("quickLinks"),
  getSocialLinks: () => fetchData("socialLinks"),
  getNavItems: () => fetchData("navItems"),
  getGalleryYears: () => fetchData("galleryYears"),
  getImpactStats: () => fetchData("impactStats"),
  getHeroContent: () => fetchData("heroContent"),
  getMissionContent: () => fetchData("missionContent"),
  getCtaSection: () => fetchData("ctaSection"),
  getContactPageContent: () => fetchData("contactPageContent"),
  getAboutPageContent: () => fetchData("aboutPageContent"),
  getFlagshipInitiatives: () => fetchData("flagshipInitiatives"),
  getAchievements: () => fetchData("achievements"),
  getPrograms: () => fetchData("programs"),
  getGalleryDescriptions: () => fetchData("galleryDescriptions"),
};

export default api;
